import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';

function runMerge(destination, key, value) {
  if (value !== undefined) {
    var keyIsUndefined = key === undefined;
    var newDestination = keyIsUndefined ? destination : destination[key];

    if (_typeof(value) === 'object' && _typeof(newDestination) === 'object' && value && newDestination && !_Array$isArray(value) && !_Array$isArray(newDestination)) {
      for (var newKey in value) {
        runMerge(newDestination, newKey, value[newKey]);
      }
    } else if (!keyIsUndefined) {
      destination[key] = value;
    }
  }
}

function merge() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  var destination = items.shift();

  _forEachInstanceProperty(items).call(items, function (value) {
    return runMerge(destination, undefined, value);
  });

  return destination;
}

export default merge;
